import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import * as Cookies from "js-cookie";
import VueCookie from "vue-cookie";
Vue.use(Vuex);
export const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      getState: key => Cookies.getJSON(key),
      setState: (key, state) =>
        Cookies.set(key, state, { expires: 3, secure: true })
    })
  ],
  state: {
    locale: (() => {
      let lang = localStorage.getItem('lang');
      if (!lang) {
        lang = 'uz';
        localStorage.setItem('lang', lang);
      }
      return lang;
    })(),
    selected_product: 0,
    xls:false,
    selected_index: null,
    changed: null,
    select_kontragent:0,
    productlist: null,
    prostatka: null,
    parent_id:0,
    saved: false,
    loading: false,
    countindex: 18,
    user_role:localStorage.getItem('user_role'),
    totatheight: 550,
    myFilter: (option, label, search) => {
      if (search.length > 2) {
        let temp = search.toLowerCase();
        let ss = option.id.toString();
        return (
          option.extra_name.toLowerCase().indexOf(temp) > -1 ||
          ss.indexOf(temp) > -1
        );
      } else {
        return option;
      }
    },
    errors: "",
    token: ""
  },

  mutations: {
    SET_LOCALE(state, locale) {
      localStorage.setItem('lang',locale);
      state.locale = locale;
    },
    SET_PRODUCT(state, productlist) {
      state.productlist = productlist;
    }
  },

  actions: {
    inrementAction({ commit }, payload) {
      commit("incrementCounter", payload);
    },
    Productlist({ commit, getters }) {
      axios.get("api/v1/product/extra-name").then(response => {
        let productlist = response.data;
        commit("SET_PRODUCT", productlist);
      });
    }
  },

  getters: {
    getLocale: state => state.locale,
    getProduct: state => state.productlist
  }
});
